import {Product} from '@shopify/hydrogen/storefront-api-types';
import {ReactElement, Suspense} from 'react';
import type {PartialDeep} from 'type-fest';
import {JudgemeReviewWidgetClient} from '@judgeme/shopify-hydrogen';

interface ProductDetailReviewProps {
  product: PartialDeep<Product>;
}
export function ProductDetailReview({
  product,
}: ProductDetailReviewProps): ReactElement {
  return (
    <div>
      {product?.id && (
        <Suspense>
          <JudgemeReviewWidgetClient id={product.id} />
        </Suspense>
      )}
    </div>
  );
}
